import e from"react";import r from"../../../../external/classnames/index.js";const a=({children:a,className:s=""})=>{const t=r("card-body",s);return e.createElement("div",{className:t},a)};export{a as CardBody};
//# sourceMappingURL=CardBody.js.map
